import { aubreyEvents } from "./character_events/aubrey.events"
import { mewoEvents } from "./character_events/mewo.events";

export const events =(k)=>{
    aubreyEvents(k);
    mewoEvents(k);
}